module.exports = __webpack_public_path__ + "img/hover_icon_ubicationtechassitance_management.76772cf8.svg";